import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { config } from 'services/config';

export const authAPI = createApi({
  reducerPath: 'authAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_URL,
    credentials: 'include',
  }),
  tagTypes: ['User', 'Chat', 'Message', 'File', 'Filter', 'Tenant'],
  endpoints: builder => ({
    sessionLogin: builder.mutation<{ message: string }, { accessToken: string }>({
      query: ({ accessToken }) => {
        return {
          url: '/session_login/',
          method: 'POST',
          body: { accessToken },
        };
      },
      invalidatesTags: [{ type: 'User', id: 'current' }],
    }),
    logout: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: '/session_logout/',
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'User', id: 'current' }],
    }),
    // getCurrentUser: builder.query<IUser, void>({
    //   query: () => ({
    //     url: 'auth/me',
    //   }),
    //   providesTags: [{ type: 'User', id: 'current' }],
    // }),
  }),
});
export const { useSessionLoginMutation, useLogoutMutation } = authAPI;
